import React, { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { SearchInput } from '@forgeglobal/design-framework';
import Table, {
  TableProps,
} from '@tcs/client-portal-common/components/molecules/Table';
import { useStyles } from './style';

interface SearchTableProps extends TableProps {
  searchValue: string;
  searchPlaceholder: string;
  onSearch: (value: string) => void;
}

const SearchTable = (props: SearchTableProps) => {
  const classes = useStyles({});
  const { searchPlaceholder, searchValue, onSearch, setPage, ...tableProps } =
    props;
  const [searchedValue, setSearchedValue] = useState(searchValue || '');
  const handleClear = () => {
    setPage(1);
    setSearchedValue('');
  };

  const handleChange = (event) => {
    setPage(1);
    setSearchedValue(event.target.value);
  };

  const searchQuery = () => {
    if (!onSearch) return;
    onSearch(searchedValue);
  };
  const delayedSearch = useMemo(
    () => debounce(searchQuery, 500),
    [searchedValue]
  );

  useEffect(() => {
    delayedSearch();

    return delayedSearch.cancel;
  }, [searchedValue, delayedSearch]);

  return (
    <div>
      <SearchInput
        placeholder={searchPlaceholder ?? ''}
        value={searchedValue}
        onChange={handleChange}
        onClear={handleClear}
        className={classes.input}
      />
      <Table {...tableProps} setPage={setPage} />
    </div>
  );
};

export default SearchTable;
